var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusicOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_533_6781)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5752 1.00977C13.5168 1.01699 13.4588 1.02829 13.4016 1.04363V1.04361L13.3959 1.04519L5.5054 3.22807C5.23864 3.3005 5.00288 3.45784 4.83405 3.6762C4.66446 3.89551 4.57178 4.16427 4.57022 4.44118H4.57021V4.44552V4.66913V6.45996V10.0147L6.12073 8.46422V7.04741L8.08014 6.5048L13.5752 1.00977ZM6.12073 11.2926L2.5992 14.8142C2.89598 14.9341 3.22043 15.0001 3.56036 15.0001C4.97441 15.0001 6.12073 13.8573 6.12073 12.4476L6.12071 12.4374L6.12073 12.432V11.2926ZM1.18439 13.4005L4.50893 10.076C4.21557 9.9593 3.89549 9.89511 3.56036 9.89511C2.14631 9.89511 1 11.0379 1 12.4476C1 12.7845 1.06546 13.1061 1.18439 13.4005ZM11.9918 5.42157L15 2.41337V4.00108V9.89859V9.90305V9.90752V9.97309C15 10.0019 14.9984 10.0303 14.9953 10.0582C14.9149 11.3957 13.8014 12.4555 12.4397 12.4555C11.0256 12.4555 9.87928 11.3128 9.87928 9.90305C9.87928 8.49334 11.0256 7.35056 12.4397 7.35056C12.7983 7.35056 13.1397 7.42406 13.4495 7.55678V5.0179L11.9918 5.42157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0.999023L1 15",
    stroke: "white",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_533_6781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicOff);
export default __webpack_public_path__ + "static/media/musicOff.072eef68f7e5f11365c8c7c70229e467.svg";
export { ForwardRef as ReactComponent };